import React from "react";
import type { Illustration } from "../util";
import { illustrationProps } from "../util";

export const ReceiptsEmpty: Illustration = (props) => (
  <svg viewBox="0 0 138 119" {...illustrationProps(props, { width: 138 })}>
    <path
      fill="#FFB3B3"
      d="M121.546 8.05c1.878 4.413 3.76 8.821 5.637 13.234l.809 1.902c.482 1.127 2.185.354 1.702-.779-1.877-4.413-3.759-8.82-5.637-13.234l-.809-1.902c-.482-1.127-2.185-.353-1.702.78Z"
    />
    <path
      fill="#FFB3B3"
      d="M119.208 19.025c4.248-1.904 8.49-3.808 12.738-5.713.593-.267 1.186-.534 1.78-.796 1.097-.494.328-2.237-.775-1.747-4.247 1.905-8.489 3.809-12.737 5.713-.593.267-1.186.534-1.78.796-1.097.495-.328 2.238.774 1.747Z"
    />
    <path
      fill="#FFB3B3"
      d="m127.447 6.906-5.129 13.367c-.243.64-.492 1.277-.735 1.918-.437 1.146 1.304 1.851 1.741.706l5.129-13.367c.243-.64.492-1.277.735-1.918.437-1.146-1.304-1.852-1.741-.706Z"
    />
    <path
      fill="#FFB3B3"
      d="M118.177 12.924c4.343 1.732 8.681 3.47 13.024 5.202l1.821.73c1.122.45 1.799-1.326.676-1.776-4.339-1.738-8.681-3.47-13.02-5.208l-1.82-.73c-1.123-.45-1.799 1.325-.677 1.776l-.004.006Z"
    />
    <path
      fill="#97A1FF"
      d="M45.614 66.03s19.422 10.236 29.63 16.061l11.56-21.323-29.632-16.061C51.712 55.322 45.614 66.03 45.614 66.03Z"
    />
    <path
      fill="#BEC4FF"
      d="m88.923 70.676 24.269-44.773c.613-1.13-.413-2.446-1.661-2.133l-1.869.468a1.478 1.478 0 0 1-1.808-1.139l-.6-2.942a1.478 1.478 0 0 0-1.746-1.153l-3.612.741a1.478 1.478 0 0 1-1.73-1.084l-.851-3.355a1.478 1.478 0 0 0-1.73-1.085l-3.674.754a1.478 1.478 0 0 1-1.732-1.09l-.672-2.699a1.478 1.478 0 0 0-1.85-1.061l-2.937.862a1.478 1.478 0 0 1-1.813-.932l-1.1-3.156a1.478 1.478 0 0 0-1.938-.888l-2.68 1.058a1.478 1.478 0 0 1-1.958-.95l-.4-1.333c-.379-1.259-2.09-1.435-2.716-.279L52.508 44.37c4.367 2.513 14.84 8.394 21.798 11.815 8.698 4.277-6.222 22.027 1.279 26.093 5.45 2.953 10.22-5.847 13.338-11.6Z"
    />
    <path
      fill="#BEC4FF"
      d="M22.954 42.8 2.778 80.023c-.668 1.232.595 2.611 1.883 2.06l.885-.38a1.478 1.478 0 0 1 1.998.934l1.022 3.395c.22.732.963 1.176 1.712 1.022l3.797-.777c.75-.153 1.492.29 1.712 1.022l.9 2.99a1.478 1.478 0 0 0 1.892.972l2.98-1.015a1.478 1.478 0 0 1 1.91 1.035l.775 3.05a1.478 1.478 0 0 0 1.849 1.055l3.442-1.008c.765-.225 1.57.199 1.82.957l1.128 3.431a1.478 1.478 0 0 0 2.042.873l2.316-1.108c.879-.42 1.916.11 2.092 1.067l.232 1.266c.252 1.372 2.083 1.675 2.748.449l15.804-29.156c9.908-18.28 16.93-15.787 16.93-15.787-4.367-2.513-21.127-12.24-28.086-15.661-2.934-1.443-15.902-12.123-23.607 2.093Z"
    />
    <path
      stroke="#7C7FFF"
      strokeLinecap="round"
      strokeWidth="2.957"
      d="M75.612 81.416c-8.174-4.43 4.605-15.032.37-23.446-2.12-4.215-5.737-4.861-34.346-20.369"
    />
    <path
      stroke="#97A1FF"
      strokeLinecap="round"
      strokeWidth="2.957"
      d="M71.92 22.558c1.226-.148 2.315-.089 3.497.624 1.184.715 2.472 2.788 3.79 3.034 3.723.696 1.666 1.74 4.973 2.541 1.923.466 3.367.866 4.85 1.508 1.295.561 2.786 2.457 5.057 3.23 2.727.928 4.542 1.545 6.632 3.388M66.735 31.387c.713-.14 1.357-.14 2.093.287.737.426 1.611 1.739 2.4 1.854 2.23.326 1.08 1.081 3.07 1.49 1.158.238 2.03.45 2.938.819.794.322 1.778 1.511 3.158 1.938 1.657.513 2.76.854 4.093 1.987M30.032 48.271c.714-.14 1.358-.139 2.093.287.737.427 3.032 2.402 3.821 2.517 2.23.326 1.079 1.082 3.07 1.49 1.157.239 2.03.45 2.938.82.794.322 1.778 1.51 3.157 1.938 1.657.512 2.76.853 4.094 1.987M17.93 67.525c.714-.14 2.435.156 3.171.582.737.427 1.954 2.107 2.743 2.222 2.23.326 1.079 1.082 3.07 1.49 1.158.239 3.247 1.61 4.155 1.98.794.321 1.778 1.51 3.158 1.938 1.657.512 2.76.853 4.093 1.987M24.654 56.829c.854-.168 1.628-.157 2.518.394.892.552 3.676 3.094 4.626 3.252 2.683.446 1.311 1.39 3.709 1.937 1.394.319 4.16 1.463 5.257 1.944.958.42 2.157 1.946 3.82 2.508 1.999.674 3.328 1.123 4.946 2.582"
    />
    <path
      fill="#FF9494"
      d="M59.792 111.518a55.569 55.569 0 0 1-1.1-2.6 1.157 1.157 0 0 1 .592-1.488c.538-.259 1.272.038 1.489.591.335.867.707 1.72 1.086 2.569a58.636 58.636 0 0 1 2.72-1.153 1.158 1.158 0 0 1 1.488.592c.259.538-.038 1.272-.592 1.488-.907.352-1.8.742-2.689 1.14.405.898.817 1.792 1.268 2.67.286.562-.07 1.238-.592 1.488-.576.28-1.218-.067-1.489-.591a54.818 54.818 0 0 1-1.253-2.639 56.46 56.46 0 0 0-2.55 1.213c-.562.287-1.238-.069-1.489-.591-.28-.576.067-1.218.592-1.489a53.11 53.11 0 0 1 2.52-1.2Z"
    />
    <circle
      cx="40.391"
      cy="8.927"
      r="4.533"
      stroke="#FFC7C7"
      strokeWidth="2.957"
    />
    <path
      fill="#FFC7C7"
      d="M128.754 55.672c-.118-.756-.515-1.48-1.108-1.896-.571-.397-1.36-.452-2.015-.366-.425.056-.794.174-1.136.465-.263.223-.447.533-.565.874-.313.136-.503.452-.537.855-.061.718.196 1.443.621 1.989.162.322.381.588.694.755.336.18.688.291 1.052.354.772.13 1.69.185 2.317-.428.246-.242.369-.551.408-.886.045-.074.084-.149.118-.223.201-.483.229-.973.151-1.493Zm-2.96.204s.011-.012 0 0Z"
    />
    <path
      fill="#FF9494"
      d="M12.52 28.962c-.117-.756-.514-1.48-1.108-1.896-.57-.396-1.36-.452-2.014-.365-.425.056-.795.173-1.136.465-.263.223-.448.532-.565.873-.313.136-.504.452-.537.855-.062.719.196 1.444.62 1.989.163.322.381.588.695.756.335.18.688.29 1.052.353.772.13 1.69.186 2.316-.428.246-.241.37-.551.409-.886a2.12 2.12 0 0 0 .117-.223c.202-.483.23-.972.151-1.493Zm-2.96.205s.011-.013 0 0Z"
    />
  </svg>
);
